import { createSlice } from "@reduxjs/toolkit";
import { nonprofitMissionAPI } from "../../../api/publicApi";

const data = {
  isLoading: false,
  error: "",
  message: null,
  data: null,
};

const nonprofitMissionSlice = createSlice({
  name: "nonprofitMission",
  initialState: data,
  reducers: {
    nonprofitMissionSlice(state) {
      state.isLoading = false;
    },
    nonprofitMissionSliceSuccess(state, action) {
      state.isLoading = true;
      state.data = action.payload;
      state.message = null;
    },
    nonprofitMissionSliceFailure(state, action) {
      state.isLoading = false;
      state.message = action.payload;
    },
    nonprofitMissionSliceReset(state) {
      state.isLoading = false;
      state.message = null;
      state.data = null;
      state.error = "";
    },
  },
});

export const nonprofitMissionHandler = () => async (dispatch: any) => {
  try {
    dispatch(nonprofitMissionAction.nonprofitMissionSlice());
    const response: any = await nonprofitMissionAPI();
    dispatch(nonprofitMissionAction.nonprofitMissionSliceSuccess(response));
  } catch (e: any) {
    dispatch(nonprofitMissionAction.nonprofitMissionSliceFailure(e?.response?.data?.message));
    dispatch(nonprofitMissionAction.nonprofitMissionSliceReset());
  }
};
export default nonprofitMissionSlice.reducer;
export const nonprofitMissionAction = nonprofitMissionSlice.actions;
